<script>
export default
{
    name: 'mv-attachment',

    props:
    {
        attachment: null,
        canRemove: Boolean,
    },

    computed:
    {
        size()
        {
            let b = this.attachment.size
            var u = 0, s=1024;
            while (b >= s || -b >= s) {
                b /= s;
                u++;
            }
            return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
        },
    },

    methods:
    {
        remove()
        {
            this.$emit('remove', this.attachment)
        },

        open()
        {
            this.isOpen = true
        },

        close()
        {
            this.isOpen = false
        },

        toggle()
        {
            this.isOpen = !this.isOpen
        },
    },

    data()
    {
        return {
            isOpen: false,
        }
    },

}
</script>

<template>
<div class="attachment" v-if="attachment">
    <div class="lightbox" v-if="isOpen" @click="close">
        <div class="content">
            <img :src="attachment.display_url">
        </div>
    </div>
    <div class="remove" v-if="canRemove" @click="remove">
        &times;
    </div>
    <div class="title">
        {{ attachment.display_name }}
    </div>
    <div class="thumb" @click="open">
        <img :src="attachment.thumbnail_url">
    </div>
    <div class="size">
        {{ size }}
    </div>
</div>
</template>

<style lang="scss">
.lightbox {
    display: block;
    position: fixed;
    z-index: 1;
    padding-top: 100px;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.6);

    .content {
        position: relative;
        margin: auto;
        padding: 0;
        width: 90%;
        max-width: 1200px;
        text-align: center;
    }

}

.thumb img {
    width: 227px;
    max-width: 227px;
    height: 128px;
    max-height: 128px;
}
</style>


// WEBPACK FOOTER //
// src/components/Attachment.vue